<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useLayout } from '@/layout/composables/layout'
import AuthService from '@/services/AuthService'
import { useUserStore } from '@/stores/user'
import { APP_ENV, APP_NAME } from '@/config'

const { toggleMenu } = useLayout()
const userStore = useUserStore()
const router = useRouter()

const userMenu = ref(null)
const userMenuItems = ref([
  {
    label: 'Logout',
    icon: 'pi pi-sign-out',
    command: async () => {
      await AuthService.logout()
      userStore.clearUser()
      router.push('/auth/login')
    },
  },
])
</script>

<template>
  <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button class="layout-menu-button layout-topbar-action" @click="toggleMenu">
        <i class="pi pi-bars"></i>
      </button>
      <router-link to="/" class="layout-topbar-logo">
        <img src="@/assets/logo/logo.svg" alt="logo" class="w-8 shrink-0 text-primary" />
        <span>{{ APP_NAME }}</span>
        <Tag v-if="APP_ENV !== 'production'" :value="APP_ENV" severity="warn" />
      </router-link>
    </div>

    <div class="layout-topbar-actions">
      <button type="button" class="layout-topbar-action" @click="userMenu.toggle($event)">
        <i class="pi pi-user"></i>
      </button>
      <Menu ref="userMenu" :model="userMenuItems" :popup="true">
        <template #start>
          <div class="px-3 py-2 border-b border-surface">
            <div class="font-medium text-sm">{{ userStore.user?.name || 'Utente' }}</div>
            <div class="text-xs text-muted-color">{{ userStore.user?.email }}</div>
          </div>
        </template>
      </Menu>
    </div>
  </div>
</template>
